import mitt from 'mitt';

import type { ErrorInfoboxEvents } from '../ErrorInfobox.types';

export const ErrorInfoboxEmitter = mitt<ErrorInfoboxEvents>();
